const videos = [...document.querySelectorAll('.js-video')];

videos.map(item => {

    const video = item.querySelector('video');
    const playPause = item.querySelector('button');

    playPause.addEventListener("click", () => {
        if (video.paused || video.ended) {
            video.play();
            playPause.setAttribute('active', true);
        } else {
            video.pause();
            playPause.removeAttribute('active');
        }
    });

    if (!!window.IntersectionObserver) {
        let isPaused = false; /* flag for auto-pausing of the video */
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio != 1 && !video.paused || entry.intersectionRatio != 1 && !video.ended) {
                    playPause.removeAttribute('active');
                    video.pause();
                    isPaused = true;
                } else if (isPaused) {
                    playPause.setAttribute('active', true);
                    video.play();
                    isPaused = false;
                }
            });
        }, { threshold: 1 });

        observer.observe(video);
    }

})


